import { selectIsUserAgent } from '../../../packages/Filters/shared/selectors';
import { IAppState } from '../../common/state';
import { getIsBrokerAvailableForBanner } from './getIsBrokerAvailableForBanner';
import { getNewbuildingBrokerSettings } from './getNewbuildingBrokerSettings';

export const getIsNewbuildingBrokerBannerVisible = (state: IAppState) => {
  const isAgent = selectIsUserAgent(state);
  const isNewbuildingBrokerBannerRandomRotationEnabled = state.isNewbuildingBrokerBannerRandomRotationEnabled;
  const isBrokerAvailable = getIsBrokerAvailableForBanner(state);
  const brokerSettings = getNewbuildingBrokerSettings(state);

  return isAgent && isNewbuildingBrokerBannerRandomRotationEnabled && !!brokerSettings?.enabled && isBrokerAvailable;
};
